import React, { useEffect, useState, useMemo } from "react";
import { guestListColumns } from "./AssignedEmpListTableData"; // Assuming your column definitions
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { hasDeleteAccess } from "../../../Common/CheckAccess";
import { getBaseUrl } from "../../../Redux/Config/AppConfig";
import ConfirmationATM from "../../../Common/ConfirmationATM";
import DataTable from "../../../Common/DataTable/DataTable";
import DataTableFooter from "../../../Common/DataTableFooter/DataTableFooter";
import DataTableHeader from "../../../Common/DataTableHeader/DataTableHeader";

const AssignedEmpListTable = () => {
  const BaseUrl = getBaseUrl();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("Name");
  const [islistDataLoading, isSetListDataLoading] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  
    const [permissions, setPermissions] = useState([]);
  
    const existingPermissions = localStorage.getItem("checkPermission");
  
    useEffect(() => {
      if (existingPermissions != undefined) {
        const parsedData = JSON.parse(existingPermissions);
        setPermissions(parsedData);
      }
    }, [existingPermissions]);

  const handleView = (id) => {
    navigate(`/front-desk/user/${id}`, { state: { userId: id, mode: "edit" } });
  };

  const handleSortChange = ({ id }) => {
    if (id !== sortBy) {
      setSortBy(id);
      setSortOrder("asc");
      return;
    }
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };

  const handleDelete = (id) => {
    setSelectedUser(id);
    setShowDeleteDialog(true);
  };

  const confirmDelete = () => {
    let token=localStorage.getItem('token')

    fetch(`${BaseUrl}/guest/delete-guest/${selectedUser?.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        toast.success("Data deleted successfully !");
        setShowDeleteDialog(false);
        fetchData();
      })
      .catch((error) => {
        toast.error("Something went wrong !");
        setShowDeleteDialog(false);
      });
  };

  const fetchData = async () => {
    isSetListDataLoading(true);
    const params = new URLSearchParams();

    params.set("page", currentPage);
    params.set("limit", pageSize);

    if (gloablFilterType === "Name" && globalFilter) {
      params.set("name", globalFilter);
    }

    if (gloablFilterType === "Phone" && globalFilter) {
      params.set("phone", globalFilter);
    }

    if (sortBy && sortOrder) {
      params.set("sortBy", sortBy);
      params.set("sortOrder", sortOrder);
    }

    let token=localStorage.getItem('token')
    let hotel_id=localStorage.getItem('hotel_id')

    await fetch(`${BaseUrl}/guest/all-guest?hotel_id=${hotel_id}&${params}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((response) => {
        const guests = response?.data?.guests || [];
        const total = response?.data?.pagination.totalResults || 0;
        setTotalEntries(total);

        const transformed = guests.map((user, index) => ({
          booking_id: user.booking_id,
          first_name: `${
            user.first_name
              ? user.first_name.charAt(0).toUpperCase() +
                user.first_name.slice(1)
              : ""
          } ${
            user.last_name
              ? user.last_name.charAt(0).toUpperCase() + user.last_name.slice(1)
              : "N/A"
          }`,
          email: user.email,
          phone: user.phone,
          occupation: user.occupation || "N/A",
          date_of_birth: user.date_of_birth || "N/A",
          nationality: user.nationality
            ? user.nationality.charAt(0).toUpperCase() +
              user.nationality.slice(1)
            : "N/A",
          actions: (
            <>
              {  hasDeleteAccess(permissions, "front_desk") &&
              <button
                className="btn"
                data-toggle="modal"
                data-target="#deleteGuest"
                onClick={() => {
                  handleDelete(user);
                }}
              >
                <i className="bi bi-trash text-danger"></i>
              </button>
              }
              <button className="btn" onClick={() => handleView(user.id)}>
                <i className="bi bi-eye text-primary"></i>
              </button>
            </>
          ),
        }));

        setData(transformed);
        isSetListDataLoading(false);
      })
      .catch((err) => {
        isSetListDataLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [pageSize, currentPage, globalFilter, sortBy, sortOrder]);

  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setCurrentPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage={"guestList"}
      />
      <DataTable
        columns={guestListColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={islistDataLoading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
      {
        <ConfirmationATM
          show={showDeleteDialog}
          onClose={() => {
            setShowDeleteDialog(false);
            setSelectedUser("");
          }}
          onConfirm={confirmDelete}
          message={`Are you sure you want to delete user ${selectedUser?.first_name} ?`}
        />
      }
    </>
  );
};

export default AssignedEmpListTable;
